import { render, staticRenderFns } from "./InvitationList.vue?vue&type=template&id=6c3c09b1&scoped=true&"
import script from "./InvitationList.vue?vue&type=script&lang=js&"
export * from "./InvitationList.vue?vue&type=script&lang=js&"
import style0 from "./InvitationList.vue?vue&type=style&index=0&id=6c3c09b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3c09b1",
  null
  
)

export default component.exports